export const INLINE_INFO_NOTE_DEFAULT_COLORS = {
  iconColor: '#4672A3',
  titleColor: '#4672A3',
  textColor: '#35516F'
}

export const INLINE_INFO_NOTE_ROOT_SX = {
  display: 'flex',
  maxWidth: '100%',
  mt: 0.5
}

export const INLINE_INFO_NOTE_ICON_SX = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 0,
  ml: -1.5,
  flexShrink: 0,
  '& svg': {
    fontSize: 18
  }
}

export const INLINE_INFO_NOTE_SINGLE_LINE_MESSAGE_SX = {
  fontSize: '0.8rem',
  lineHeight: 1.4,
  whiteSpace: { xs: 'normal', md: 'nowrap' }
}

export const INLINE_INFO_NOTE_TITLE_SX = {
  fontWeight: 700
}

export const INLINE_INFO_NOTE_STACKED_TITLE_SX = {
  ...INLINE_INFO_NOTE_TITLE_SX,
  fontSize: '0.95rem',
  lineHeight: 1.3
}

export const INLINE_INFO_NOTE_STACKED_MESSAGE_SX = {
  fontSize: '0.8rem',
  lineHeight: 1.5
}
